import { render, staticRenderFns } from "./EstDes4.vue?vue&type=template&id=f5cd4812&scoped=true&"
import script from "./EstDes4.vue?vue&type=script&lang=js&"
export * from "./EstDes4.vue?vue&type=script&lang=js&"
import style0 from "./EstDes4.vue?vue&type=style&index=0&id=f5cd4812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cd4812",
  null
  
)

export default component.exports